import { render } from "./DashboardTitle.vue?vue&type=template&id=ed66a0e8"
import script from "./DashboardTitle.vue?vue&type=script&lang=js"
export * from "./DashboardTitle.vue?vue&type=script&lang=js"

import "./DashboardTitle.vue?vue&type=style&index=0&id=ed66a0e8&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__